import React from "react";
import ReactDOM from "react-dom";
import AppView from "./views/AppView";

ReactDOM.render(<AppView />, document.getElementById("root"));

